import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import app from './module/app'
import account from './module/account'
import gray from './module/gray'
import menu from './module/menu'
import page from './module/page'
import search from './module/search'
import ua from './module/ua'
import db from './module/db'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  modules: {
    user,
    app,
    account,
    gray,
    menu,
    page,
    search,
    ua,
    db
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js